/**
 * Store module-level pour le token Cloudflare Turnstile.
 *
 * Le composant `<TurnstileWidget>` appelle `setTurnstileToken()` quand le
 * challenge est résolu ; `secureGeminiService.generateContent` lit le token
 * via `getTurnstileToken()` avant chaque appel anonyme.
 *
 * Approche module-singleton pour éviter de plomber le token à travers les
 * couches (chat interface → message sender → gemini service → edge function).
 * Le token Turnstile a une durée de vie courte (~5 min) et le widget se
 * re-render automatiquement, donc `currentToken` est rafraîchi en continu.
 */

let currentToken: string | null = null;

/** Stocke le dernier token reçu de Cloudflare Turnstile. */
export function setTurnstileToken(token: string | null): void {
  currentToken = token;
}

/** Récupère le token actuel, ou `null` si aucun n'est disponible. */
export function getTurnstileToken(): string | null {
  return currentToken;
}

/** Réinitialise le token (à appeler après consommation côté serveur). */
export function clearTurnstileToken(): void {
  currentToken = null;
}
